import React from 'react';

interface MaximizeIconProps {
  className?: string;
}

function MaximizeIcon({ className = 'w-4 h-4 text-white' }: MaximizeIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`lucide lucide-maximize2 ${className}`}
        >
            <polyline points="15 3 21 3 21 9" />
            <polyline points="9 21 3 21 3 15" />
            <line x1="21" x2="14" y1="3" y2="10" />
            <line x1="3" x2="10" y1="21" y2="14" />
        </svg>
    );
}

export default MaximizeIcon;
